export default "__VITE_ASSET__BTtjId7F__"